import React, { useState } from "react";
import { Box, Button, Stack } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import AddIcon from '@mui/icons-material/Add';
import AddCustomMetricsModal from "../modals/dashboard-queries/AddCustomMetricsModal";

const useStyles = makeStyles((theme) => ({
    masonryElement: {
        display: 'inline-block',
        width: '80%',
        height: 'auto',
        overflow: 'hidden',
        padding: '12px 16px',
        borderRadius: 16,
        border: `2px solid ${theme.colors.primary['100']}`,
        background: theme.colors.primary['50'],
        transition: 'all 0.2s ease',
        "&:hover": {
            border: `2px solid ${theme.colors.primary['200']}`,
            background: theme.colors.primary['50'],
            boxShadow: '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12)',
        },
    },
    iconButton: {
        minWidth: 32,
        padding: 'unset !important',
        fontFamily: 'Inter !important',
        fontSize: '1rem',
        fontWeight: 500,
        color: theme.colors.neutral['500'],
        textTransform: 'none',
        "& > .MuiButton-startIcon": {
            width: 'auto',
            height: 32,
            padding: 6,
            borderRadius: '50%',
            background: '#E0F1F1',
            "& > .MuiSvgIcon-root": {
                fontSize: 22,
                color: theme.palette.primary.main,
            }
        },
        "&:hover": {
            backgroundColor: 'inherit',
        },
    },
}));

const AddMetrics: React.FC<{}> = () => {
    const classes = useStyles();
    const [addCustomMetricsModalOpen, setAddCustomMetricsModalOpen] = useState<boolean>(false);

    return (<>
        <Box width="100%" sx={{ cursor: 'pointer' }}
            onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setAddCustomMetricsModalOpen(true);
            }}>
            <Stack className={classes.masonryElement} alignItems="flex-start">
                <Button variant="text"
                    className={classes.iconButton}
                    startIcon={<AddIcon />}>
                    {'Add a metric'}
                </Button>
            </Stack>
        </Box>
        {addCustomMetricsModalOpen && (
            <AddCustomMetricsModal
                isOpen={addCustomMetricsModalOpen}
                onClose={() => {
                    setAddCustomMetricsModalOpen(false);
                }}>
            </AddCustomMetricsModal>
        )}
    </>);
}

export default AddMetrics;